<template>
    <v-card flat tile class="my-3">
        <v-toolbar dense flat dark color="primary" class="clickable" @click="goto" v-track="{ category: 'Urgency and Impact', action: 'click', label: 'See All' }">
            <v-row no-gutters align="center">
                <v-col>
                    <v-toolbar-title class="title text-uppercase font-weight-bold">
                        <span>Urgency and Impact</span>
                    </v-toolbar-title>
                </v-col>
                <v-col cols="auto" class="text-right">
                    <span class="title ml-3">
                        <a class="white--text">
                            <span>See All</span>
                            <v-icon right>mdi-arrow-right</v-icon>
                        </a>
                    </span>
                </v-col>
            </v-row>
        </v-toolbar>
        <v-card flat tile outlined color="primary">
            <v-card flat tile outlined color="white" class="pt-5 px-5">
                <v-row no-gutters justify="center">
                    <v-col cols="auto" align="right">
                        <div class="pa-6 y-axis">
                            <div class="y-axis-label">Urgency</div>
                            <div class="y-axis-arrow"></div>
                        </div>
                    </v-col>
                    <v-col>
                        <v-row no-gutters justify="center">
                            <v-col cols="4">
                                <PriorityCount :priority="priorities[0]"></PriorityCount>
                            </v-col>
                            <v-col cols="4">
                                <PriorityCount :priority="priorities[3]"></PriorityCount>
                            </v-col>
                            <v-col cols="4">
                                <PriorityCount :priority="priorities[6]"></PriorityCount>
                            </v-col>
                        </v-row>
                        <v-row no-gutters justify="center">
                            <v-col cols="4">
                                <PriorityCount :priority="priorities[1]"></PriorityCount>
                            </v-col>
                            <v-col cols="4">
                                <PriorityCount :priority="priorities[4]"></PriorityCount>
                            </v-col>
                            <v-col cols="4">
                                <PriorityCount :priority="priorities[7]"></PriorityCount>
                            </v-col>
                        </v-row>
                        <v-row no-gutters justify="center">
                            <v-col cols="4">
                                <PriorityCount :priority="priorities[2]"></PriorityCount>
                            </v-col>
                            <v-col cols="4">
                                <PriorityCount :priority="priorities[5]"></PriorityCount>
                            </v-col>
                            <v-col cols="4">
                                <PriorityCount :priority="priorities[8]"></PriorityCount>
                            </v-col>
                        </v-row>
                    </v-col>
                </v-row>
                <v-row no-gutters justify="center">
                    <v-col cols="auto" align="right">
                        <div class="pa-6">
                            <div class="y-axis-spacer"></div>
                        </div>
                    </v-col>
                    <v-col>
                        <div class="pa-6">
                            <div class="x-axis-arrow"></div>
                            <div class="x-axis-label">Impact</div>
                        </div>
                    </v-col>
                </v-row>
            </v-card>
            <v-card flat tile outlined color="white" class="px-5 pb-3 mt-n5">
                <SearchResultsTable :standards="selectedPriorityStandards" :sortable="false" :show-featured-icons="false" :area-of-need-columns="true"></SearchResultsTable>
            </v-card>
        </v-card>
    </v-card>
</template>

<script>
    import { get } from 'vuex-pathify';
    import { priorities } from '@/common';
    import PriorityCount from '@/components/PriorityCount';
    import SearchResultsTable from '@/components/SearchResultsTable';
    import router from '@/router';
    import { statuses } from '@/common';

    export default {
        components: { PriorityCount, SearchResultsTable },
        data: () => ({
            statusIndex: 3,
            priorities
        }),
        computed: {
            selectedPriorityStandards: get('selectedPriorityStandards')
        },
        methods: {
            goto() {
                this.$store.commit('resetFilters', true);
                this.$store.set('filters@selectedStatuses', [statuses[this.statusIndex]]);
                this.$store.dispatch('search').then(() => {
                    router.push({ path: this.$store.get('searchPath') });
                });
            }
        }
    };
</script>

<style lang="scss" scoped>
    $table-spacing: 4px;

    .results ::v-deep table {
        border-spacing: 0 $table-spacing !important;
        margin-bottom: #{$table-spacing * -4};
    }

    .clickable {
        cursor: pointer;
    }

    .y-axis {
        position: relative;
        height: 100%;
    }
    .y-axis-spacer {
        width: 4px;
    }
    .x-axis-label, .y-axis-label {
        text-transform: uppercase;
        font-size: 120%;
        font-weight: bold;
        text-align: center;
        color: var(--v-primary-base);
    }
    .y-axis-label {
        position: absolute;
        bottom: 0;
        transform: rotate(180deg);
        writing-mode: vertical-rl;
        text-orientation: mixed;
        height: 100%;
        margin-left: -30px;
    }
    .x-axis-arrow {
        position: relative;
        background: var(--v-primary-base);
        height: 4px;
        width: 100%;
        &:before {
            content: "";
            position: absolute;
            width: 0;
            height: 0;
            border: 10px solid transparent;
            top: -8px;
            right: -20px;
            border-left: 20px solid var(--v-primary-base);
        }
    }
    .y-axis-arrow {
        position: relative;
        background: var(--v-primary-base);
        height: 100%;
        width: 4px;
        &:before {
            content: "";
            position: absolute;
            width: 0;
            height: 0;
            border: 10px solid transparent;
            left: -8px;
            top: -20px;
            border-bottom: 20px solid var(--v-primary-base);
        }
    }
</style>
